import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { Provider as GlueConfigProvider } from '@tencent/glue-react-ui';
import { useConfig } from '../hooks/useConfig';
export var ADP_COMBINE_PREFIX = 'adp-combine';
export var DEFAULT_CONFIG = {
  prefixCls: ADP_COMBINE_PREFIX,
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    return customizePrefixCls || (suffixCls ? "".concat(ADP_COMBINE_PREFIX, "-").concat(suffixCls) : ADP_COMBINE_PREFIX);
  },
  componentSizeMap: {
    sm: {
      height: 30
    },
    md: {
      height: 34
    },
    lg: {
      height: 38
    }
  },
  antdComponentSizeMap: {
    lg: 'large',
    md: 'middle',
    sm: 'small'
  }
};
export var ConfigContext = React.createContext(DEFAULT_CONFIG);
export var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children;
  var value = useConfig();
  return React.createElement(ConfigContext.Provider, {
    value: value
  }, React.createElement(GlueConfigProvider, {
    value: {
      prefix: value.prefixCls
    }
  }, children));
};
export var withAdpCombine = function withAdpCombine(InnerComponent) {
  return function (props) {
    return React.createElement(ConfigProvider, null, React.createElement(InnerComponent, _objectSpread({}, props)));
  };
};
export var withRefAdpCombine = function withRefAdpCombine(InnerComponent) {
  var refComp = forwardRef(function (props, ref) {
    return React.createElement(ConfigProvider, null, React.createElement(InnerComponent, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    })));
  });
  return refComp;
};
export var PRESET_PRIMARY_COLORS = {
  red: '#F73C3F',
  orange: '#F86B0C',
  yellow: '#F9A805',
  green: '#32BF76',
  cyan: '#44BFD4',
  blue: '#296BEF',
  purple: '#722ED1',
  magenta: '#E72DB9',
  grey: '#4D5869'
};